var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "more_apply" },
    [
      _vm.isShowSetting
        ? _c("div", { staticClass: "setting-stu" }, [
            _c(
              "div",
              {
                staticClass: "stu-item",
                on: { click: _vm.showSearchStuDialog }
              },
              [
                _c("i", { staticClass: "icon-enquiry-personnel" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item" }, [_vm._v("查询人员")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stu-item", on: { click: _vm.addStudent } },
              [
                _c("i", { staticClass: "icon-add-student" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item" }, [_vm._v("添加学生")])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.moreList.length > 0
        ? _c("div", { staticClass: "more step_two" }, [
            _c(
              "div",
              {
                staticClass: "more-item apply",
                class: { hoverApply: _vm.isShowMore },
                on: {
                  mouseenter: function($event) {
                    return _vm.showMore()
                  },
                  mouseleave: function($event) {
                    return _vm.showMore()
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isShowMore,
                      expression: "!isShowMore"
                    }
                  ],
                  staticClass: "icon-more-functions apply-icon"
                }),
                _vm._v(" "),
                _vm.isShowMore ? _c("p", [_vm._v("更多应用")]) : _vm._e(),
                _vm._v(" "),
                _vm.isShowMore
                  ? _c("div", { staticClass: "menuWrap" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.moreList, function(more, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              on: {
                                click: function($event) {
                                  return _vm.listFn(more)
                                }
                              }
                            },
                            [
                              more.code.toLowerCase() === "sycp"
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/user/LOGO_sycp.svg"),
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              more.code.toLowerCase() === "bms"
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/common/more-LOGO-01.svg"),
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              more.code.toLowerCase() === "emes"
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/common/more-LOGO-02.svg"),
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              more.code.toLowerCase() === "mces"
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/common/more-LOGO-03.svg"),
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              more.code.toLowerCase() === "ei"
                                ? _c("img", {
                                    attrs: {
                                      src: require("../../assets/imgs/user/LOGO_ei.svg"),
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.moreFitler(more.code)))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialogTool",
          attrs: {
            title: _vm.title,
            visible: _vm.showAddDialog,
            "append-to-body": true,
            width: "38%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showAddDialog = $event
            },
            closed: _vm.closeHandle
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "studentInfoForm",
              staticClass: "myform_inline",
              attrs: {
                model: _vm.studentInfoForm,
                rules: _vm.formInline,
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "年级：", prop: "gradeId" } },
                [
                  _c(
                    "el-select",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.operat != 3,
                          expression: "operat != 3"
                        }
                      ],
                      staticStyle: { width: "80%" },
                      attrs: { placeholder: "请选择年级" },
                      on: { change: _vm.getCurClass },
                      model: {
                        value: _vm.studentInfoForm.gradeId,
                        callback: function($$v) {
                          _vm.$set(_vm.studentInfoForm, "gradeId", $$v)
                        },
                        expression: "studentInfoForm.gradeId"
                      }
                    },
                    _vm._l(_vm.gradeList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.operat == 3,
                          expression: "operat == 3"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.studentInfoForm.gradeName))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "班级：", prop: "classId" } },
                [
                  _vm.operat != 3
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: { placeholder: "请选择班级" },
                          on: { change: _vm.changeClass },
                          model: {
                            value: _vm.studentInfoForm.classId,
                            callback: function($$v) {
                              _vm.$set(_vm.studentInfoForm, "classId", $$v)
                            },
                            expression: "studentInfoForm.classId"
                          }
                        },
                        _vm._l(_vm.classList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.busId }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.studentInfoForm.className))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isShowHaveSidItem
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否有学籍号：", prop: "isHaveSid" } },
                    [
                      _vm.operat != 3
                        ? _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "80%" },
                              on: { change: _vm.changeIsHaveSid },
                              model: {
                                value: _vm.studentInfoForm.isHaveSid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.studentInfoForm,
                                    "isHaveSid",
                                    $$v
                                  )
                                },
                                expression: "studentInfoForm.isHaveSid"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { width: "48%" },
                                  attrs: { label: 1, border: "" }
                                },
                                [_vm._v("孩子有学籍号")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { width: "49%" },
                                  attrs: { label: 0, border: "" }
                                },
                                [_vm._v("生成临时学籍号")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.operat == 3
                        ? _c("div", [
                            _vm.studentInfoForm.isHaveSid == 1
                              ? _c("span", [_vm._v("孩子有学籍号")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.studentInfoForm.isHaveSid == 0
                              ? _c("span", [_vm._v("临时学籍号")])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.studentInfoForm.isHaveSid == 1
                ? _c(
                    "el-form-item",
                    {
                      ref: "replaceSid",
                      attrs: { label: "学籍号：", prop: "sid" }
                    },
                    [
                      _vm.operat != 3
                        ? _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: { placeholder: "请输入学生学籍号" },
                            model: {
                              value: _vm.studentInfoForm.sid,
                              callback: function($$v) {
                                _vm.$set(_vm.studentInfoForm, "sid", $$v)
                              },
                              expression: "studentInfoForm.sid"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.operat == 3
                        ? _c("span", [_vm._v(_vm._s(_vm.studentInfoForm.sid))])
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    {
                      ref: "replaceSid",
                      attrs: { label: "学籍号：", prop: "sids" }
                    },
                    [
                      _vm.operat != 3
                        ? _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: { placeholder: "请输入学生学籍号" },
                            model: {
                              value: _vm.studentInfoForm.sid,
                              callback: function($$v) {
                                _vm.$set(_vm.studentInfoForm, "sid", $$v)
                              },
                              expression: "studentInfoForm.sid"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.operat == 3
                        ? _c("span", [_vm._v(_vm._s(_vm.studentInfoForm.sid))])
                        : _vm._e()
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "姓名：", prop: "name" } },
                [
                  _vm.operat != 3
                    ? _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: { placeholder: "请输入学生姓名" },
                        model: {
                          value: _vm.studentInfoForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.studentInfoForm, "name", $$v)
                          },
                          expression: "studentInfoForm.name"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("span", [_vm._v(_vm._s(_vm.studentInfoForm.name))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别：", prop: "sex" } },
                [
                  _vm.operat != 3
                    ? _c(
                        "el-radio-group",
                        {
                          staticStyle: { width: "80%" },
                          model: {
                            value: _vm.studentInfoForm.sex,
                            callback: function($$v) {
                              _vm.$set(_vm.studentInfoForm, "sex", $$v)
                            },
                            expression: "studentInfoForm.sex"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "48%" },
                              attrs: { label: 1, border: "" }
                            },
                            [_vm._v("男")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "49%" },
                              attrs: { label: 2, border: "" }
                            },
                            [_vm._v("女")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("div", [
                        _vm.studentInfoForm.sex == 1
                          ? _c("span", [_vm._v("男")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.studentInfoForm.sex == 2
                          ? _c("span", [_vm._v("女")])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "民族：", prop: "nation" } },
                [
                  _vm.operat != 3
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: { filterable: "", placeholder: "请选择民族" },
                          on: { change: _vm.changeNation },
                          model: {
                            value: _vm.studentInfoForm.nation,
                            callback: function($$v) {
                              _vm.$set(_vm.studentInfoForm, "nation", $$v)
                            },
                            expression: "studentInfoForm.nation"
                          }
                        },
                        _vm._l(_vm.directoryData, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.itemName, value: item.value }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("span", [_vm._v(_vm._s(_vm.studentInfoForm.itemName))])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否独生子女：", prop: "isOnlyChild" } },
                [
                  _vm.operat != 3
                    ? _c(
                        "el-radio-group",
                        {
                          staticStyle: { width: "80%" },
                          model: {
                            value: _vm.studentInfoForm.isOnlyChild,
                            callback: function($$v) {
                              _vm.$set(_vm.studentInfoForm, "isOnlyChild", $$v)
                            },
                            expression: "studentInfoForm.isOnlyChild"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "48%" },
                              attrs: { label: 1, border: "" }
                            },
                            [_vm._v("是")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "49%" },
                              attrs: { label: 0, border: "" }
                            },
                            [_vm._v("否")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("div", [
                        _vm.studentInfoForm.isOnlyChild == 1
                          ? _c("span", [_vm._v("是")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.studentInfoForm.isOnlyChild == 0
                          ? _c("span", [_vm._v("否")])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否住校：", prop: "isResidence" } },
                [
                  _vm.operat != 3
                    ? _c(
                        "el-radio-group",
                        {
                          staticStyle: { width: "80%" },
                          model: {
                            value: _vm.studentInfoForm.isResidence,
                            callback: function($$v) {
                              _vm.$set(_vm.studentInfoForm, "isResidence", $$v)
                            },
                            expression: "studentInfoForm.isResidence"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "48%" },
                              attrs: { label: 1, border: "" }
                            },
                            [_vm._v("是")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { width: "49%" },
                              attrs: { label: 0, border: "" }
                            },
                            [_vm._v("否")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.operat == 3
                    ? _c("div", [
                        _vm.studentInfoForm.isResidence == 1
                          ? _c("span", [_vm._v("是")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.studentInfoForm.isResidence == 0
                          ? _c("span", [_vm._v("否")])
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.operat != 3
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "save-btn",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.checkForm($event)
                            }
                          }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "cancle-btn",
                          attrs: { type: "default" },
                          on: { click: _vm.closeHandle }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.operat == 3
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "save-btn",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.addStudentHandle($event)
                            }
                          }
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "cancle-btn",
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toBackEdit($event)
                            }
                          }
                        },
                        [_vm._v("返回修改")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialogTool",
          attrs: {
            title: "修改教师信息",
            visible: _vm.showTeacherDialog,
            "append-to-body": true,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showTeacherDialog = $event
            },
            closed: _vm.closeTeacherHandle
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "editTeacherForm",
              staticClass: "myform_inline",
              attrs: {
                model: _vm.editTeacherForm,
                rules: _vm.formRules,
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名：", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: { placeholder: "请输入学生姓名" },
                    model: {
                      value: _vm.editTeacherForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.editTeacherForm, "name", $$v)
                      },
                      expression: "editTeacherForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号：", prop: "phone" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: { placeholder: "请输入学生学籍号" },
                    model: {
                      value: _vm.editTeacherForm.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.editTeacherForm, "phone", $$v)
                      },
                      expression: "editTeacherForm.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showTeacherDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: [
                      function($event) {
                        _vm.showTeacherDialog = false
                      },
                      function($event) {
                        $event.stopPropagation()
                        return _vm.saveTeacherInfo($event)
                      }
                    ]
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialogTool",
          attrs: {
            title: "查询学生/教师/校长信息",
            visible: _vm.showSearchDialog,
            "append-to-body": true,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showSearchDialog = $event
            },
            closed: _vm.closeSearchHandle
          }
        },
        [
          _c(
            "div",
            { staticClass: "term-comment" },
            [
              _c(
                "el-form",
                {
                  ref: "setTeacherParams",
                  staticClass: "save-form-inline",
                  attrs: { inline: true, model: _vm.setTeacherParams }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "80%" },
                      attrs: { label: "", prop: "teacherSearch" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          type: "text",
                          placeholder: "输入姓名/学籍号/手机号查询"
                        },
                        model: {
                          value: _vm.setTeacherParams.search,
                          callback: function($$v) {
                            _vm.$set(_vm.setTeacherParams, "search", $$v)
                          },
                          expression: "setTeacherParams.search"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { width: "13%" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-default",
                          attrs: { type: "primary" },
                          on: { click: _vm.getStudentList }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableDataList,
                "header-cell-style": _vm.getRowClass,
                height: "400"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "姓名",
                  "show-overflow-tooltip": "",
                  align: "center",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "性别", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.sex == 1
                              ? "男"
                              : scope.row.sex == 2
                              ? "女"
                              : ""
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "roleName",
                  label: "角色",
                  align: "center",
                  width: "80"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orgName",
                  label: "位置",
                  "show-overflow-tooltip": "",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "account",
                  label: "账号",
                  "show-overflow-tooltip": "",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.grantTrial(scope.row)
                              }
                            }
                          },
                          [_vm._v("授权")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.editHandle(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.resetPwd(scope.row)
                              }
                            }
                          },
                          [_vm._v("重置密码")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }